import axios from 'axios'

import store from '@/vuex/store'
import CSRF from '@/services/csrf'

const LOGIN_ENDPOINT = '/api/login/'
const MAGIC_LINK_ENDPOINT = '/api/users/magic-link/'
const MAGIC_LINK_REPORT_ENDPOINT = '/api/users/magic-link-report/'

export default {
  magicLinkAuth,
  magicLinkReportAuth,
  login,
  logout,
  freeEnter,
  requireAuth,
  requireStaffAuth,
  getHeaders,
}

/**
 * @function     magicLinkAuth
 * @description  Authenticate a user with a magic token.
 * @param        userId <uuid>
 * @param        magicToken <uuid>
 **/
 function magicLinkAuth(userId, magicToken) {
  //console.log("***magicLinkAuth***")
  const data = {
    user_id: userId,
    magic_token: magicToken,
  }
  const promise = axios.post(MAGIC_LINK_ENDPOINT, data, { headers: CSRF.getHeaders() })
  var dataToReturn = promise.then(response => response.data).catch(console.log('Registration API error-ACT'))
  //console.log("dataToReturn-auth.js") 
  //console.log(dataToReturn)
  return dataToReturn
}


/** 
 * @function     magicLinkReportAuth
 * @description  Authenticate a user with a magic token.
 * @param        userId <uuid>
 * @param        magicToken <uuid>
**/
 function magicLinkReportAuth(userId, magicToken) {
  const data = {
    user_id: userId,
    magic_token: magicToken,
  }
  const promise = axios.post(MAGIC_LINK_ENDPOINT, data, { headers: CSRF.getHeaders() })
  var dataToReturn = promise.then(response => response.data).catch(console.log('Registration API error-RPT'))
  //console.log("dataToReturn-auth.js")
  //console.log(dataToReturn)
  return dataToReturn
}

function login(email, password) {
  const promise = axios.post(LOGIN_ENDPOINT, { email, password }, { headers: CSRF.getHeaders() })
  return promise
    .then(response => response.data)
    .catch(error => {
      // console.log('Login API error')
      throw error
    })
}

/*
 * @function requireAuth
 * @description vue-router beforeEnter-style function to check user auth
 *              status and redirect appropriately.
 */
function requireAuth(to, from, next) {
  if (!isLoggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath },
    })
  } else {
    next()
  }
}

function requireStaffAuth(to, from, next) {
  if (!isStaff() || !isLoggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath },
    })
  } else {
    next()
  }
}

function freeEnter(to, from, next) {
  if (isLoggedIn()) {
    const path = to.name === from.name ? '/' : from.path
    next({
      path,
      replace: true,
    })
  } else {
    next()
  }
}

function isLoggedIn() {
  return store.state.userLoggedInStatus
}

function isStaff() {

  if (store.state.user) {
    return store.state.user.is_staff
  } else {
    return false
  }
}

/*
 * @function getHeaders
 * @description Get the authentication headers, based on the token stored
 *              in state.
 */
function getHeaders() {
  // TODO: Assert that a token exists, otherwise the header won't be valid.
  return {
    headers: {
      Authorization: `Token ${store.state.authToken}`,
    },
  }
}

/*
 * @function logout
 * @description Perform logout by clearing the Vuex store.
 *
 * TODO: Logout should also call an API endpoint to terminate the Django session.
 */
function logout() {
  store.commit('LOGOUT_USER')
}
